<template>
  <section
    class="mx-auto min-h-[11in] w-[8.5in] border border-gray-400 bg-white px-[0.75in] pb-[0.75in] before:mx-auto before:mb-12 before:block before:w-full before:text-center before:text-text-sm before:text-gray-500 before:content-['(page_break)'] first-of-type:before:content-[''] print:min-h-0 print:w-auto print:break-before-page print:border-0 print:p-0 print:before:hidden print:first-of-type:break-before-auto print:[&_:is(h1,h2,h3,h4,h5,h6)]:break-after-avoid print:[&_img]:break-inside-avoid"
  >
    <slot />
  </section>
</template>
